import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class VideoControls extends PureComponent {
  static propTypes = {
    isVideoPlaying: PropTypes.bool.isRequired,
    hasVideo: PropTypes.bool,
    hasAudio: PropTypes.bool,
    onAudioClick: PropTypes.func.isRequired,
    onVideoClick: PropTypes.func.isRequired,
    stream: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    hasVideo: true,
    hasAudio: true,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {stream} = nextProps;
    const {stream: prevStream} = prevState;

    return stream && stream === prevStream ? null : {videoMute: false, audioMute: false, stream};
  }

  constructor(props) {
    const {stream} = props;
    super(props);
    this.state = {videoMute: false, audioMute: false, stream};
  }

  onAudioIconClick = () => {
    const {audioMute} = this.state;
    const {onAudioClick, isVideoPlaying} = this.props;
    if (!isVideoPlaying) {
      this.setState({audioMute: !audioMute}, () => onAudioClick(!audioMute));
    }
  };

  onVideoIconClick = () => {
    const {videoMute} = this.state;
    const {onVideoClick} = this.props;
    this.setState({videoMute: !videoMute}, () => onVideoClick(!videoMute));
  };

  iconClassnames = (icon, has, mute) => classNames(
    'video-controls__icon',
    {
      icon: true,
      [`icon-${icon}`]: true,
      'video-controls__icon_disabled': !has,
      'video-controls__icon_muted': has && mute,
    }
  );

  renderControls() {
    const {hasVideo, hasAudio, isVideoPlaying} = this.props;
    const {videoMute, audioMute} = this.state;
    const audioClick = hasAudio ? {onClick: this.onAudioIconClick} : {};
    const videoClick = hasVideo ? {onClick: this.onVideoIconClick} : {};

    const audioProps = {
      className: this.iconClassnames('microphone-slash', hasAudio, isVideoPlaying || audioMute),
      'aria-disabled': isVideoPlaying,
      ...audioClick,
    };
    const videoProps = {
      className: this.iconClassnames('eye-slash', hasVideo, videoMute),
      ...videoClick,
    };

    return (
      <div className="video-controls">
        <div {...audioProps}/>
        <div {...videoProps}/>
      </div>
    );
  }

  render() {
    const {stream} = this.props;
    return stream ? this.renderControls() : null;
  }
}
